export default "__VITE_ASSET__BnAertYC__"